import {BaseModuleState} from "../../../infrastructure/models/base-module-state";
import {BaseMobxState} from "../../../infrastructure/mobx/base-mobx-state";
import {NavigationManager} from "../../../core/managers/navigation-manager";
import {AppStore} from "../../../core/app/app-store";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../core/models/device.view-model";
import {TermsUtils} from "../../../infrastructure/utils/terms-utils";
import {NavigationTabsModuleConfig} from "../navigation-tabs-module.config";
import {computed} from "mobx";
import {NavigationTabsModuleEntityViewModel} from "./entities/navigation-tabs-module.entity.view-model";
import {CompetitorViewModel} from "../../../domain/common/competitor/models/competitor-view-model";
import {CompetitionViewModel} from "../../../domain/common/competition/models/competition-view-model";
import {FullGameDomainModel} from "../../../domain/full-game/models/full-game-domain-model";
import {NavigationTabsModuleGameCenterViewModel} from "./entities/navigation-tabs-module.game-center.view-model";
import {NAVIGATION_TABS_CONTEXT} from "../../../core/app/consts";
import {NavigationTabsModuleCompetitionViewModel} from "./entities/navigation-tabs-module.competition.view-model";
import {NavigationTabsModuleCompetitorViewModel} from "./entities/navigation-tabs-module.competitor.view-model";
import {NavigationTabsModuleMatchesCompetitorViewModel} from "./entities/navigation-tabs-module.matches.competitor.view-model";
import {NavigationTabsModuleMatchesCompetitionViewModel} from "./entities/navigation-tabs-module.matches.competition.view-model";

export class NavigationTabsModuleState extends BaseModuleState {
  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, NavigationTabsModuleConfig];

  get isPopulated(): Boolean {
    return this.entityContext?.tabs?.length > 0;
  }

  @computed get entityContext() {
    let entityContext: NavigationTabsModuleEntityViewModel = null;
    const isNewMatchesTab: Boolean = this.props.context === NAVIGATION_TABS_CONTEXT.newMatchesTab;
    const isCompetitionTab: Boolean = this.props.context === NAVIGATION_TABS_CONTEXT.competition;
    const isCompetitorTab: Boolean = this.props.context === NAVIGATION_TABS_CONTEXT.competitor;

    if (this.props.entity instanceof CompetitionViewModel) {

      if(isNewMatchesTab) {
        entityContext = new NavigationTabsModuleMatchesCompetitionViewModel(this.props.entity, this.currentLinkModel, this.terms);
      } else if(isCompetitionTab) {
        entityContext = new NavigationTabsModuleCompetitionViewModel(this.props.entity, this.currentLinkModel, this.terms);
      }
    } else if (this.props.entity instanceof CompetitorViewModel) {
      if(isNewMatchesTab) {
        entityContext = new NavigationTabsModuleMatchesCompetitorViewModel(this.props.entity, this.currentLinkModel, this.terms);
      } else if(isCompetitorTab) {
        entityContext = new NavigationTabsModuleCompetitorViewModel(this.props.entity, this.currentLinkModel, this.terms);
      }
    } else if(this.props.entity instanceof FullGameDomainModel) {
      entityContext = new NavigationTabsModuleGameCenterViewModel(this.props.entity, this.currentLinkModel, this.terms, this.props.currentIndex);
    }

    return entityContext;
  }
}
